import { MenuOpenOutlined } from "@mui/icons-material"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import { useEffect, useState } from "react"

import AccordionGroup, { AccordionRow } from "@components/accordion_group"
import LeftDrawer from "@components/persist_drawer"
import SectionBar from "@components/section_bar"
import { PRIMARY } from "@constants/colors"
import { useCustomerPageContext } from "@contexts/customer"
import useTranslate from "@hooks/use_translate"
import { useLocation, useNavigate } from "react-router-dom"

export default function CustomerPageLeftDrawer() {
  const { isLeftDrawerOpen, toggleIsLeftDrawerOpen, translate } =
    useCustomerPageContext()

  const location = useLocation()
  const initialSelectedValue = location.pathname.startsWith(
    "/customers/payments"
  )
    ? "/customers/payments"
    : "/customers"
  const [selectedValue, setSelectedValue] = useState(initialSelectedValue)
  const navigate = useNavigate()

  const handleClickNavigate = (value: string) => {
    navigate(value)
    setSelectedValue(value)
  }
  const data: {
    title: string
    rowList: AccordionRow[]
    rightIconGroup?: React.ReactNode
    isDefaultOpen: boolean
  }[] = [
    {
      title: translate("status"),
      rowList: [
        {
          label: "All",
          value: "/customers"
        },
        {
          label: "Payments",
          value: "/customers/payments"
        }
      ],
      isDefaultOpen: true
    }
  ]

  useEffect(() => {
    setSelectedValue(
      location.pathname.startsWith("/customers/payments")
        ? "/customers/payments"
        : "/customers"
    )
  }, [location.pathname])

  useEffect(() => {
    if (isLeftDrawerOpen) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = "auto"
    }

    return () => {
      document.body.style.overflow = "auto"
    }
  }, [isLeftDrawerOpen])

  return (
    <LeftDrawer
      isOpen={!!isLeftDrawerOpen}
      header={<Header setClose={toggleIsLeftDrawerOpen} />}
      sx={{
        borderRight: 1,
        borderColor: "divider",
        width: "16rem",
        minWidth: "16rem",
        maxWidth: "16rem"
      }}
    >
      <AccordionGroup
        accordionList={data}
        selectedValue={selectedValue}
        onClick={handleClickNavigate}
      />
    </LeftDrawer>
  )
}

function Header({ setClose }: { setClose?: () => void }) {
  const { translate } = useTranslate()
  return (
    <SectionBar
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        p: 1
      }}
    >
      <Typography p={1} variant="h6">
        {translate("customers")}
      </Typography>
      <IconButton
        disableRipple
        sx={{
          ":hover": {
            color: PRIMARY
          }
        }}
        onClick={setClose}
      >
        <MenuOpenOutlined />
      </IconButton>
    </SectionBar>
  )
}
